import { createUseStyles } from 'react-jss'

import { blue } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  createLeadAdsFormLink: {
    textDecoration: 'none',
    color: [blue, '!important']
  }
})

export default useStyles
